export const tag = {
    name: 'tag',
    params: {
      types: ['order', 'development_projects', 'sale_opportunities', 'materials']
    }
}

export type TagType = 'order' | 'development_projects' | 'sale_opportunities' | 'materials';
